















































import Vue from 'vue';
import { Prop, Component, Model, Watch } from 'vue-property-decorator';


/**
 * Helpers
 */
import { getMinDate, getMaxDate } from "@/utils/date-helpers";

/**
 * Types
 */
import { FilteredResponseModel } from '@/api/admin';


const paginationDefault = {
	sortBy: '',
	descending: false,
	rowsPerPage: 10,
	page: 1
};

/**
 * Composant de tableaux de données.
 */
@Component
export default class DataTable extends Vue {
	/** Propriétés */
	@Prop({ required: true })
	headers!: any[];

	@Prop()
	items!: any[];

	@Prop()
	search!: string;

	@Prop({ default: () => paginationDefault })
	pagination!: any;

	@Prop()
	fetchingDelegate!: (page: number, itemsPerPage: number, orderBy: string[]) => Promise<FilteredResponseModel<any>>;


	/** Attributs */
	paginationDefault: any | null = null;
	fetchedItems: any[] | null = null;
	totalItems: number | null = null;
	isLoading = false;

	/**
	 * Méthodes
	 */
	async created() {
		const pagination = this.pagination ? this.pagination : {};

		this.paginationDefault = {
			...paginationDefault,
			...pagination,
		};

		await this.fetchDataFromAPI();
	}

	changeSort(column: string) {
		if (this.paginationDefault.sortBy === column) {
			this.paginationDefault.descending = !this.paginationDefault.descending;
		}
		else {
			this.paginationDefault.sortBy = column;
			this.paginationDefault.descending = false;
		}
	}

	async fetchDataFromAPI() {
		if (this.fetchingDelegate) {
			const { sortBy, descending, page, rowsPerPage } = this.paginationDefault;
			this.isLoading = true;
			try {
				const fetchResult = await this.fetchingDelegate(page, rowsPerPage, [`${sortBy}${descending ? '|desc' : ''}`]);

				this.fetchedItems = fetchResult.items;
				this.totalItems = fetchResult.totalItems;
			}
			catch (error) {

			}
			this.isLoading = false;
		}
	}

	get displayedItems() {
		if (this.fetchedItems) {
			return this.fetchedItems;
		}
		else {
			return this.items;
		}
	}

	/** Watchers */
	@Watch('paginationDefault', { deep: true })
	async paginationDefaultChanged() {
		await this.fetchDataFromAPI();
	}
}
